module.exports = __webpack_public_path__ + "static/img/lrs_pingming_img@2x.6cd196d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lrsimages/rules/lrs_pingming_img@2x.png
// module id = CSVl
// module chunks = 23